import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Link, useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import "../styles/Clients.css";

const statusLabels = {
  1: "Probleme (Cu Revenire)",
  2: "Activ",
  3: "Montaj finalizat",
  4: "Dosar Prosumator",
  5: "Certificat de Racordare",
};

const Clients = () => {
  const { user } = useContext(AuthContext); // 🔹 Obținem utilizatorul autentificat
  const navigate = useNavigate(); // 🔹 Pentru navigare
  const [clients, setClients] = useState([]);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedStatus, setSelectedStatus] = useState(searchParams.get("status") || "");
  const [selectedEchipa, setSelectedEchipa] = useState(searchParams.get("echipa") || "");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    if (!user) {
      navigate("/login");
      return;
    }

    let url = "https://casaverde.marenergy.ro/api.php?action=get_clients";

    // 🔹 Adaugăm filtrul de status și echipă
    const params = new URLSearchParams();
    if (selectedStatus) params.append("status", selectedStatus);
    if (selectedEchipa) params.append("echipa", selectedEchipa);
    if (searchTerm) params.append("search", searchTerm);

    axios
      .get(`${url}&${params.toString()}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((response) => {
        if (Array.isArray(response.data)) {
          setClients(response.data);
        } else {
          setError("Format invalid de date");
        }
      })
      .catch((error) => {
        console.error("Eroare la încărcarea clienților:", error);
        setError("Nu s-au putut încărca clienții");
      });
  }, [user, navigate, selectedStatus, selectedEchipa, searchTerm]);

  // Actualizare status din URL dacă se schimbă
  useEffect(() => {
    const statusFromURL = searchParams.get("status");
    const echipaFromURL = searchParams.get("echipa");
    if (statusFromURL) setSelectedStatus(statusFromURL);
    if (echipaFromURL) setSelectedEchipa(echipaFromURL);
  }, [searchParams]);

    // 🔹 Gestionare filtre multiple fără a suprascrie `searchParams`
  const handleFilterChange = () => {
    const newParams = {};
    if (selectedStatus) newParams.status = selectedStatus;
    if (selectedEchipa) newParams.echipa = selectedEchipa;
    setSearchParams(newParams);
  };

  // Calculare paginare
  const indexOfLastClient = currentPage * itemsPerPage;
  const indexOfFirstClient = indexOfLastClient - itemsPerPage;
  const currentClients = clients.slice(indexOfFirstClient, indexOfLastClient);
  const totalPages = Math.ceil(clients.length / itemsPerPage);

  return (
    <div className="container">
      <div className="user-info">
        <span className="user-name">👤 {user?.name || "Utilizator"}</span>
      </div>
      <div className="clients-logo">
        <Link to="/dashboard">
          <img src="/images/Logo.webp" alt="Logo" className="clientprofile-logo" />
        </Link>
      </div>
      <div className="d-flex align-items-center justify-content-center my-4">
        <h1 className="text-center">Lista Clientilor</h1>
      </div>

      {/* FILTRARE */}
      <div className="d-flex gap-3 mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Caută după nume..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        {/* 🔹 Filtru STATUS */}
        <select
          className="form-control"
          value={selectedStatus}
          onChange={(e) => setSelectedStatus(e.target.value)}
        >
          <option value="">Toate statusurile</option>
          {Object.entries(statusLabels).map(([key, label]) => (
            <option key={key} value={key}>{label}</option>
          ))}
        </select>

        {/* 🔹 Filtru ECHIPĂ */}
        <select
          className="form-control"
          value={selectedEchipa}
          onChange={(e) => setSelectedEchipa(e.target.value)}
        >
          <option value="">Toate echipele</option>
          <option value="HUSI">HUSI</option>
          <option value="IASI">IASI</option>
        </select>

        <button className="btn btn-primary" onClick={handleFilterChange}>
          Filtrează
        </button>
      </div>

      {/* AFIȘARE CLIENȚI */}
      {error ? (
        <p className="text-danger text-center">{error}</p>
      ) : (
        <>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nume</th>
                  <th>Echipa</th>
                  <th>Adresă</th>
                  <th>Status</th>
                  <th>Acțiuni</th>
                </tr>
              </thead>
              <tbody>
                {currentClients.length > 0 ? (
                  currentClients.map((client) => (
                    <tr key={client.id}>
                      <td>{client.id}</td>
                      <td>{client.name}</td>
                      <td>{client.echipa || "N/A"}</td>
                      <td>{client.address || "N/A"}</td>
                      <td>{statusLabels[client.status] || "Necunoscut"}</td>
                      <td>
                        <Link to={`/clients/${client.id}`} className="btn btn-info btn-sm">
                          Detalii
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      Nu există clienți
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* PAGINARE */}
          {totalPages > 1 && (
            <nav className="d-flex justify-content-center mt-4">
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>Înapoi</button>
                </li>

                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter(page => Math.abs(page - currentPage) <= 1)
                  .map((page) => (
                    <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                      <button className="page-link" onClick={() => setCurrentPage(page)}>{page}</button>
                    </li>
                  ))}

                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>Înainte</button>
                </li>
              </ul>
            </nav>
          )}
        </>
      )}
    </div>
  );
};

export default Clients;